import {AnimationData, Tween} from '@wonderlandengine/tweenjs';

import BlobIdleAnimation from './blob@idle.json' assert {type: 'json'};
import BlobFullAnimation from './blob@full.json' assert {type: 'json'};
import BlobAbsorbAnimation from './blob@absorb.json' assert {type: 'json'};
import BlobBlinkAnimation from './blob@blink.json' assert {type: 'json'};
import BlobBlinkFullAnimation from './blob@fullBlink.json' assert {type: 'json'};
import BlobPopAnimation from './blob@pop.json' assert {type: 'json'};
import BlobPressAnimation from './blob@press.json' assert {type: 'json'};
import BlobPokeAnimation from './blob@poke.json' assert {type: 'json'};

import FruitDropAnimation from './fruit@drop.json' assert {type: 'json'};
import FruitEmbedAnimation from './fruit@embed.json' assert {type: 'json'};
import FruitIdleAnimation from './fruit@idle.json' assert {type: 'json'};
import FruitPopAnimation from './fruit@pop.json' assert {type: 'json'};
import FruitSquashAnimation from './fruit@squash.json' assert {type: 'json'};

/**
 * Singleton class that holds all the animations for the board objects
 *
 * Different board objects need to have different animations. It's not
 * possible to define these in Wonderland, so we need to define them here.
 * Animations can be refered to by name and the data is returned. This way
 * the animations can be set in the editor, but still be defined in code.
 */
export class BoardAnimations {
    private static _instance: BoardAnimations;
    static get instance() {
        if (!this._instance) {
            this._instance = new BoardAnimations();
        }
        return this._instance;
    }

    private _animations: Map<string, AnimationData> = new Map();

    /**
     *
     */
    constructor() {
        this._animations.set('blob@idle', BlobIdleAnimation);
        this._animations.set('blob@full', BlobFullAnimation);
        this._animations.set('blob@absorb', BlobAbsorbAnimation);
        this._animations.set('blob@blink', BlobBlinkAnimation);
        this._animations.set('blob@fullBlink', BlobBlinkFullAnimation);
        this._animations.set('blob@pop', BlobPopAnimation);
        this._animations.set('blob@press', BlobPressAnimation);
        this._animations.set('blob@poke', BlobPokeAnimation);

        this._animations.set('fruit@drop', FruitDropAnimation);
        this._animations.set('fruit@embed', FruitEmbedAnimation);
        this._animations.set('fruit@idle', FruitIdleAnimation);
        this._animations.set('fruit@pop', FruitPopAnimation);
        this._animations.set('fruit@squash', FruitSquashAnimation);
    }

    getAnimation(name: string): AnimationData {
        return this._animations.get(name);
    }
}
